"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.grCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var grCountry = exports.grCountry = function grCountry(t) {
  return {
    id: 'GR',
    name: t('Greece'),
    flag: '🇬🇷',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{3}\s?[0-9]{2}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 100 00 or 602 00',
    phonePrefix: '30',
    phoneLength: 10,
    pricingVersion: 14,
    timezone: 'Europe/Athens',
    currency: 'EUR'
  };
};